module.exports = __webpack_public_path__ + "media/images/bg-blur-b1f834f501762b8a4e795a91d2700d9c.png";